module.exports = __webpack_public_path__ + "img/apply-hero.1696f2a0.png";